import { useContext } from "react";
import { useLocation } from "react-router-dom";
import {
  ASSET_AS_PAIR_EXCHANGES,
  CONTRACTS_EXCHANGES,
} from "@shared/common/constants";
import { sortItemsByExchangeOrder } from "@shared/utils/misc";
import { AccountFormContext } from "@shared/features/common/AccountForm.context";
import { useExchangesMetadata } from "@shared/utils/hooks/misc";
import {
  useTradingIntent,
  getPracticeExchange,
} from "features/onboarding/guided/intent";

const usePracticeExchange = () => {
  const { exchangesData } = useContext(AccountFormContext)!;
  const { getExchangeMetadata } = useExchangesMetadata();
  const { intent: selectedIntent } = useTradingIntent();
  const intent = selectedIntent || "dca";
  const query = new URLSearchParams(useLocation().search);
  const options =
    sortItemsByExchangeOrder(
      (exchangesData || []).filter(
        (option) =>
          option.should_display !== false &&
          (option.tag === "Spot" || option.tag === "Futures") &&
          !ASSET_AS_PAIR_EXCHANGES.has(option.exchange) &&
          !CONTRACTS_EXCHANGES.has(option.exchange) &&
          !getExchangeMetadata(option.exchange)?.is_inverse_exchange &&
          (intent !== "hedging" || option.tag === "Futures")
      )
    ) || [];
  const labeledOptions = options.map((option) => ({
    ...option,
    exchange_display:
      option.tag &&
      !option.exchange_display.toLowerCase().includes(option.tag.toLowerCase())
        ? `${option.exchange_display} ${option.tag}`
        : option.exchange_display,
  }));
  const requestedExchange =
    query.get("exchange") || getPracticeExchange(intent);
  const selected =
    labeledOptions.find((option) => option.exchange === requestedExchange) ||
    labeledOptions.find(
      (option) => option.exchange === getPracticeExchange(intent)
    ) ||
    labeledOptions[0];
  const exchange = selected?.exchange || getPracticeExchange(intent);
  const exchangeDisplay =
    selected?.exchange_display ||
    (exchange === "Binance" ? "Binance Spot" : exchange);
  return { options: labeledOptions, selected, exchange, exchangeDisplay };
};
export default usePracticeExchange;
